/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

const StyledSVG = styled.svg`
  .cls-1 {
    fill: ${(props) => props.theme.palette.highlight.main};
  }
  .cls-2 {
    fill: ${(props) => props.theme.palette.common.white};
  }
  height: 100%;
`;
export const SVG = ({ className, showSimpleVersion = false }: { className?: string; showSimpleVersion?: boolean }) => {
  return showSimpleVersion ? (
    <StyledSVG className={className} viewBox='0 0 44.117 20.469'>
      <g className='cls-1'>
        <path fill='none' stroke='#37424a' strokeWidth={0.254} d='M16.22 18.37h27.892' />
        <g fill='#ebeced' stroke='#37424a'>
          <path strokeWidth={0.366} d='M30.06 6.14H8.292V.497H30.06z' />
          <path strokeWidth={0.254} d='M17.97 18.37h-.706V6.199h.706zM29.31 18.37h-.706V6.199h.706z' />
        </g>
        <text
          xmlSpace='preserve'
          x={134.378}
          y={138.014}
          strokeWidth={0.265}
          fontFamily='sans-serif'
          fontSize={3.881}
          transform='translate(-122.26 -133.28)'
        >
          <tspan x={134.378} y={138.014} fill='#37424a'>
            THEWA
          </tspan>
        </text>
        <g stroke='#37424a'>
          <path fill='#ebeced' strokeWidth={0.22099779} d='M37.898 16.785h-5.79v1.582h5.79z' />
          <path
            fill='#ebeced'
            strokeWidth={0.2540016}
            d='M34.407.127h.919a3.613 3.613 0 0 1 3.613 3.613v13.047h-7.862V3.457a3.33 3.33 0 0 1 3.33-3.33z'
          />
          <path fill='#fff' strokeWidth={0.2540016} d='M34.672 6.198h4.266V3.74c0-.336-.047-.66-.133-.97h-4.133z' />
        </g>
        <g fill='#37424a'>
          <text
            x={142.972}
            y={150.117}
            strokeWidth={0.353}
            fontFamily="'Arial Rounded MT Bold'"
            fontSize={2.822}
            fontWeight='bold'
            transform='translate(-107.68 -144.718) scale(.99999)'
          >
            <tspan x={142.972} y={150.117} fontFamily='Arial'>
              H
            </tspan>
          </text>
          <text x={144.988} y={150.302} transform='translate(-107.68 -144.718) scale(.99999)'>
            <tspan x={144.988} y={150.302} strokeWidth={0.353} fontFamily='Arial' fontSize={1.587} fontWeight='bold'>
              2
            </tspan>
          </text>
        </g>
        <g stroke='#38434b'>
          <path fill='#ebeced' strokeWidth={0.2540016} d='M24.964 18.37H19.58v-8.076h5.383z' />
          <path
            fill='none'
            strokeWidth={0.2540016}
            d='M24.19 17.282c0 .122-.099.222-.22.222h-3.446a.222.222 0 0 1-.22-.222v-2.966c0-.122.1-.222.22-.222h3.446c.121 0 .22.1.22.222z'
          />
          <path
            fill='#38434b'
            strokeWidth={0.13476196}
            d='m27.426 12.234-.288-.093-.084.149-.057.154.02.069-.119.142c-.082.106-.05.401-.027.685.02.201.201.177.25.174l.274-.01c.096 0 .096.046.117.115.02.055.042.123.126.1l.179-.056c.028-.016.053-.084.039-.128l-.153-.548a.348.348 0 0 1 .002-.159c.085-.336.01-.491-.28-.594z'
          />
          <path
            fill='#38434b'
            strokeWidth={0.13476196}
            d='m27.137 12.142-.088.157-.308-.363-.702-.396.078-.167.703.395z'
          />
        </g>
        <path
          fill='#fff'
          stroke='#fff'
          strokeWidth={0.13476196}
          d='m27.024 13.282-.032-.345c.001-.057.011-.092.08-.125.033-.01.085-.027.09.036l.042.427c.002.048-.013.058-.073.073-.07.013-.098-.035-.107-.066z'
        />
        <path
          fill='none'
          stroke='#38434b'
          strokeWidth={0.2540016}
          d='M24.964 13.525c1.068 0 .06 3.939 1.625 3.939 1.485 0 1.614-2.424 1.112-3.764'
        />
        <path fill='#fff' stroke='#38434b' strokeWidth={0.25964608} d='M24.237 10.96H20.3v2.154h3.936z' />
        <g fill='#37424a' strokeWidth={0.353} fontWeight='bold'>
          <text
            x={142.972}
            y={150.117}
            fontFamily="'Arial Rounded MT Bold'"
            fontSize={2.822}
            transform='translate(-122.24 -133.404) scale(.99999)'
          >
            <tspan x={142.972} y={150.117} fontFamily='Arial'>
              H
            </tspan>
          </text>
          <text
            x={144.988}
            y={150.302}
            fontFamily="'Myriad Pro'"
            fontSize={1.587}
            transform='translate(-122.24 -133.404) scale(.99999)'
          >
            <tspan x={144.988} y={150.302} fontFamily='Arial'>
              2
            </tspan>
          </text>
        </g>
        <g stroke='#37424a' strokeLinejoin='round'>
          <g strokeWidth={0.72}>
            <g fill='#ebeced'>
              <path
                d='M403.63 327.41s.1 7.234 0 12.189c-.1 4.954-1.902 11.709-1.902 11.709s-5.953 2.052-7.004 2.302-3.504-.05-9.108-.6c-5.604-.551-9.371-1.375-10.049-1.702-.819-.394-1.328-.775-1.972-1.595-2.57-3.268-3.04-18.475-2.731-24.125.362-6.604 1.02-9.356 1.521-9.407.501-.05 19.386-1.101 21.237-.9.795.086 2.935.301 5.118.518a12.21 12.21 0 0 0-.274 2.625c0 3.093 1.053 5.603 2.351 5.603 1.299 0 2.353-2.51 2.353-5.603a12.5 12.5 0 0 0-.19-2.205l1.65.162v8.806c0 1.602-1 2.223-1 2.223z'
                transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
              />
              <path
                d='m378.47 315.84-2.8.148c-.013-.127-.026-.281.153-.658.562-1.181 1.278-1.713 1.278-1.713l3.064-.109-.018.027c-.692.159-1.291 1.034-1.677 2.305zM397.76 352.65c1.912-.636 3.975-1.347 3.975-1.347s1.802-6.756 1.902-11.709 0-12.55 0-12.55 1-.26 1-1.862v28.423z'
                transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
              />
            </g>
            <path
              fill='#fff'
              d='M384.22 351.31c4.698.518 8.835 1.086 8.888.359.42-5.884.093-15.507-.882-15.57-.976-.064-19.148-1.273-20.011-.969 0 0-.195 3.182.221 6.813s1.297 7.668 2.177 7.806c.879.137 4.908 1.043 9.607 1.561zM395.79 349.71l4.594-1.801s.501-3.402.651-5.904.526-4.129.25-4.203c-.275-.076-2.379.5-2.879.449-.499-.049-2.15-1.051-2.576-.951-.425.101-.65.051-.7 1.303-.05 1.25.306 10.607.331 10.832.025.224.329.275.329.275z'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
            <path
              fill='#ebeced'
              d='m414.06 317.79-2.638-.396c.54-1.022 1.162-1.493 1.162-1.493l3.065-.107-.019.027c-.629.145-1.185.879-1.57 1.969z'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
            <path
              fill='none'
              d='m370.87 327.53 1.801-.266 1.135-1.935 2.134-7.893 9.823-.521 1.961 7.986 2.293 2.295 3.727.334 9.89-.359'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
            <path
              fill='#fff'
              d='M378.56 315.8c.427-1.402 1.118-2.316 1.9-2.316.75 0 1.416.837 1.848 2.138-1.275.059-2.547.119-3.748.178z'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
            <g fill='#39a9dc'>
              <path
                d='m373.94 325.19 13.779-.281M373.94 324.29l13.779-.281M374.31 323.46l12.939-.477M374.31 322.61l12.939-.477M374.72 321.75l12.006-.604'
                transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
              />
            </g>
            <g fill='#fff'>
              <path
                d='M417.37 319.9c0-2.277-.774-4.123-1.73-4.123-.957 0-1.731 1.846-1.731 4.123s.774 4.123 1.731 4.123c.956 0 1.73-1.846 1.73-4.123zM428.05 320.93c0-1.553-.528-2.811-1.18-2.811s-1.18 1.258-1.18 2.811.528 2.813 1.18 2.813 1.18-1.26 1.18-2.813zM388.63 322.31s.367 1.201.801 1.801c.433.601 1.968.701 2.668.734.701.033 1.926 0 1.926 0s.009-1.834-.391-2.068c-.4-.235-5.004-.467-5.004-.467zM370.88 324.86s2.001-.002 2.335-.309c.334-.306.346-.441.346-.441l.142-1.533s-1.215-.03-1.889 0c-.455.017-.751.092-.751.092z'
                transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
              />
            </g>
            <path
              fill='#ebeced'
              d='m398.86 315.33-.324.465-2.436-.244c.096-.276-.121-.299.17-.914.563-1.182 1.279-1.715 1.279-1.715l3.064-.108-.019.028c-.724.166-1.352 1.115-1.734 2.488z'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
            <path
              fill='none'
              strokeMiterlimit={10}
              d='M400.82 324.03c-1.299 0-2.352-2.51-2.352-5.604 0-3.095 1.053-5.605 2.352-5.605s2.352 2.51 2.352 5.605c0 3.094-1.053 5.604-2.352 5.604z'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
          </g>
          <path
            fill='#ebeced'
            strokeWidth={0.572}
            d='m425.65 319.53-2.084-.313c.416-.744.871-1.085.871-1.085l2.436-.086-.015.023c-.479.109-.903.654-1.208 1.461z'
            transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
          />
          <path
            fill='#ebeced'
            strokeLinecap='square'
            strokeWidth={0.72}
            d='M404.63 353.61v-37.229l9.522 1.429a8.747 8.747 0 0 0-.242 2.094c0 2.277.775 4.123 1.731 4.123s1.73-1.846 1.73-4.123a9.38 9.38 0 0 0-.141-1.633l8.609 1.291c-.096.406-.15.873-.15 1.371 0 1.553.528 2.813 1.179 2.813.653 0 1.181-1.26 1.181-2.813 0-.371-.031-.726-.087-1.052l2.689.404v15.611z'
            transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
          />
        </g>
      </g>
    </StyledSVG>
  ) : (
    <StyledSVG className={className} version='1.1' id='Ebene_1' viewBox='0 0 44.118 32'>
      <g className='cls-1' id='g4126'>
        <g strokeWidth={1.705}>
          <path
            fill='#5e6a71'
            d='M7.844 21.8h.368c.84 0 1.52.68 1.52 1.52l.006 2.158c.312-.205.667-.273 1.09-.298.097-.006.296.005.39.016V27.2l-.172-.002c-.705 0-1.276.42-1.276 1.367 0 .989.746 1.366 1.276 1.366h.214l.01 1.973a5.92 5.92 0 0 1-.442.016c-1.12 0-2.092-.739-2.574-1.82-.32-.705-.352-1.43-.394-2.23-.009-.126-.016-6.07-.016-6.07zm-3.226 0h.369c.84 0 1.52.68 1.52 1.52l.009 4.352c.007.236.01 1.129.127 1.42.15.372.443.662.809.78v2.044c-1.062-.064-1.972-.791-2.43-1.833-.313-.688-.345-1.413-.388-2.213-.008-.126-.016-6.07-.016-6.07zm-3.184 0h.369c.839 0 1.52.68 1.52 1.52l.009 4.352c.007.236.01 1.129.127 1.42.15.372.443.662.809.78v2.044c-1.062-.064-1.972-.791-2.43-1.833-.224-.49-.304-1-.347-1.544-.018-.125-.037-.273-.09-.395-.243-.575-.815-.9-1.401-.905V25.21a3.046 3.046 0 0 1 1.442.359z'
          />
          <g fill='#981e32'>
            <path d='M14.42 27.64h-.624v2.27h-.503v-2.27h-.648v-.442h1.815c0 .14-.016.306-.04.443zM16.34 29.91h-1.497v-2.712h.503v2.265h1.03c0 .15-.016.302-.036.447zM17.857 28.369c.354.482.671.966 1.001 1.517-.165.032-.37.048-.523.048l-.788-1.2-.266.315v.86h-.495v-2.711h.495v1.195h.024l.97-1.22c.137 0 .395.02.527.049zM18.996 28.908v-.382h.756v.382zM21.663 27.64h-.624v2.27h-.503v-2.27h-.648v-.442h1.815c0 .14-.016.306-.04.443zM23.28 29.91v-1.453c0-.165-.053-.281-.314-.281a.741.741 0 0 0-.439.137v1.597h-.458v-2.962a4.13 4.13 0 0 1 .458-.032v1.09h.025c.193-.172.366-.237.579-.237.358 0 .607.194.607.644v1.497h-.458zM25.816 28.976h-1.183v.037c0 .342.109.503.507.503.19 0 .43-.057.555-.13.045.121.085.29.105.431-.173.085-.47.133-.668.133-.644 0-1.002-.354-1.002-1.062 0-.757.378-1.12.897-1.12.552 0 .805.347.805.898 0 .09-.004.214-.016.31zm-1.179-.31h.728c.004-.023.004-.092.004-.116 0-.298-.116-.43-.35-.43-.24 0-.378.164-.382.546zM27.308 28.268a.85.85 0 0 0-.19-.02.641.641 0 0 0-.422.145v1.517h-.459v-2.085c.13-.016.314-.028.46-.028v.27h.023c.21-.274.346-.298.48-.298a.55.55 0 0 1 .152.024c0 .157-.02.322-.044.475zM29.992 29.91v-1.457c0-.169-.069-.277-.286-.277a.598.598 0 0 0-.386.136v1.598h-.459v-1.453c0-.177-.068-.281-.278-.281a.662.662 0 0 0-.394.137v1.597h-.459v-2.085c.129-.016.314-.028.459-.028v.21h.024c.193-.173.338-.238.543-.238.21 0 .379.073.471.274.21-.21.39-.274.616-.274.342 0 .607.177.607.644v1.497zM31.767 29.95c-.551 0-.925-.33-.925-1.09 0-.688.39-1.09.937-1.09.532 0 .934.305.934 1.09 0 .716-.415 1.09-.946 1.09zm.008-1.786c-.27 0-.438.177-.438.696 0 .515.14.696.43.696s.455-.177.455-.696c0-.507-.16-.696-.447-.696zM35.154 29.95c-.788 0-1.19-.495-1.19-1.4 0-.974.51-1.392 1.227-1.392.257 0 .57.044.768.128a2.809 2.809 0 0 1-.08.46 1.563 1.563 0 0 0-.66-.146c-.443 0-.717.193-.717.97 0 .684.242.937.66.937.109 0 .27-.016.354-.048v-.555h-.41a2.47 2.47 0 0 1-.04-.43h.945v1.295c-.189.097-.539.181-.857.181zM38.78 29.91v-1.457c0-.169-.068-.277-.286-.277a.598.598 0 0 0-.386.136v1.598h-.459v-1.453c0-.177-.068-.281-.277-.281a.663.663 0 0 0-.395.137v1.597h-.458v-2.085c.129-.016.314-.028.458-.028v.21h.025c.193-.173.338-.238.543-.238.21 0 .378.073.47.274.21-.21.39-.274.616-.274.342 0 .608.177.608.644v1.497zM40.587 29.95c-.314 0-.6-.072-.817-.241v-2.76a4.13 4.13 0 0 1 .459-.033v1.075h.024a.675.675 0 0 1 .523-.222c.426 0 .756.278.756 1.01 0 .749-.35 1.171-.945 1.171zm.048-1.774a.614.614 0 0 0-.406.145v1.142a.6.6 0 0 0 .334.089c.334 0 .479-.193.479-.728 0-.503-.141-.648-.407-.648zM43.496 29.91v-1.187h-1.038v1.187h-.503v-2.712h.503v1.074h1.038v-1.074h.503v2.712z' />
          </g>
        </g>
        <path fill='none' stroke='#37424a' strokeWidth={0.254} d='M16.22 18.37h27.892' />
        <g fill='#ebeced' stroke='#37424a'>
          <path strokeWidth={0.366} d='M30.06 6.14H8.292V.497H30.06z' />
          <path strokeWidth={0.254} d='M17.97 18.37h-.706V6.199h.706zM29.31 18.37h-.706V6.199h.706z' />
        </g>
        <text
          xmlSpace='preserve'
          x={134.378}
          y={138.014}
          strokeWidth={0.265}
          fontFamily='sans-serif'
          fontSize={3.881}
          transform='translate(-122.26 -133.28)'
        >
          <tspan x={134.378} y={138.014} fill='#37424a'>
            THEWA
          </tspan>
        </text>
        <g stroke='#37424a'>
          <path fill='#ebeced' strokeWidth={0.22099779} d='M37.898 16.785h-5.79v1.582h5.79z' />
          <path
            fill='#ebeced'
            strokeWidth={0.2540016}
            d='M34.407.127h.919a3.613 3.613 0 0 1 3.613 3.613v13.047h-7.862V3.457a3.33 3.33 0 0 1 3.33-3.33z'
          />
          <path fill='#fff' strokeWidth={0.2540016} d='M34.672 6.198h4.266V3.74c0-.336-.047-.66-.133-.97h-4.133z' />
        </g>
        <g fill='#37424a'>
          <text
            x={142.972}
            y={150.117}
            strokeWidth={0.353}
            fontFamily="'Arial Rounded MT Bold'"
            fontSize={2.822}
            fontWeight='bold'
            transform='translate(-107.68 -144.718) scale(.99999)'
          >
            <tspan x={142.972} y={150.117} fontFamily='Arial'>
              H
            </tspan>
          </text>
          <text x={144.988} y={150.302} transform='translate(-107.68 -144.718) scale(.99999)'>
            <tspan x={144.988} y={150.302} strokeWidth={0.353} fontFamily='Arial' fontSize={1.587} fontWeight='bold'>
              2
            </tspan>
          </text>
        </g>
        <g stroke='#38434b'>
          <path fill='#ebeced' strokeWidth={0.2540016} d='M24.964 18.37H19.58v-8.076h5.383z' />
          <path
            fill='none'
            strokeWidth={0.2540016}
            d='M24.19 17.282c0 .122-.099.222-.22.222h-3.446a.222.222 0 0 1-.22-.222v-2.966c0-.122.1-.222.22-.222h3.446c.121 0 .22.1.22.222z'
          />
          <path
            fill='#38434b'
            strokeWidth={0.13476196}
            d='m27.426 12.234-.288-.093-.084.149-.057.154.02.069-.119.142c-.082.106-.05.401-.027.685.02.201.201.177.25.174l.274-.01c.096 0 .096.046.117.115.02.055.042.123.126.1l.179-.056c.028-.016.053-.084.039-.128l-.153-.548a.348.348 0 0 1 .002-.159c.085-.336.01-.491-.28-.594z'
          />
          <path
            fill='#38434b'
            strokeWidth={0.13476196}
            d='m27.137 12.142-.088.157-.308-.363-.702-.396.078-.167.703.395z'
          />
        </g>
        <path
          fill='#fff'
          stroke='#fff'
          strokeWidth={0.13476196}
          d='m27.024 13.282-.032-.345c.001-.057.011-.092.08-.125.033-.01.085-.027.09.036l.042.427c.002.048-.013.058-.073.073-.07.013-.098-.035-.107-.066z'
        />
        <path
          fill='none'
          stroke='#38434b'
          strokeWidth={0.2540016}
          d='M24.964 13.525c1.068 0 .06 3.939 1.625 3.939 1.485 0 1.614-2.424 1.112-3.764'
        />
        <path fill='#fff' stroke='#38434b' strokeWidth={0.25964608} d='M24.237 10.96H20.3v2.154h3.936z' />
        <g fill='#37424a' strokeWidth={0.353} fontWeight='bold'>
          <text
            x={142.972}
            y={150.117}
            fontFamily="'Arial Rounded MT Bold'"
            fontSize={2.822}
            transform='translate(-122.24 -133.404) scale(.99999)'
          >
            <tspan x={142.972} y={150.117} fontFamily='Arial'>
              H
            </tspan>
          </text>
          <text
            x={144.988}
            y={150.302}
            fontFamily="'Myriad Pro'"
            fontSize={1.587}
            transform='translate(-122.24 -133.404) scale(.99999)'
          >
            <tspan x={144.988} y={150.302} fontFamily='Arial'>
              2
            </tspan>
          </text>
        </g>
        <g stroke='#37424a' strokeLinejoin='round'>
          <g strokeWidth={0.72}>
            <g fill='#ebeced'>
              <path
                d='M403.63 327.41s.1 7.234 0 12.189c-.1 4.954-1.902 11.709-1.902 11.709s-5.953 2.052-7.004 2.302-3.504-.05-9.108-.6c-5.604-.551-9.371-1.375-10.049-1.702-.819-.394-1.328-.775-1.972-1.595-2.57-3.268-3.04-18.475-2.731-24.125.362-6.604 1.02-9.356 1.521-9.407.501-.05 19.386-1.101 21.237-.9.795.086 2.935.301 5.118.518a12.21 12.21 0 0 0-.274 2.625c0 3.093 1.053 5.603 2.351 5.603 1.299 0 2.353-2.51 2.353-5.603a12.5 12.5 0 0 0-.19-2.205l1.65.162v8.806c0 1.602-1 2.223-1 2.223z'
                transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
              />
              <path
                d='m378.47 315.84-2.8.148c-.013-.127-.026-.281.153-.658.562-1.181 1.278-1.713 1.278-1.713l3.064-.109-.018.027c-.692.159-1.291 1.034-1.677 2.305zM397.76 352.65c1.912-.636 3.975-1.347 3.975-1.347s1.802-6.756 1.902-11.709 0-12.55 0-12.55 1-.26 1-1.862v28.423z'
                transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
              />
            </g>
            <path
              fill='#fff'
              d='M384.22 351.31c4.698.518 8.835 1.086 8.888.359.42-5.884.093-15.507-.882-15.57-.976-.064-19.148-1.273-20.011-.969 0 0-.195 3.182.221 6.813s1.297 7.668 2.177 7.806c.879.137 4.908 1.043 9.607 1.561zM395.79 349.71l4.594-1.801s.501-3.402.651-5.904.526-4.129.25-4.203c-.275-.076-2.379.5-2.879.449-.499-.049-2.15-1.051-2.576-.951-.425.101-.65.051-.7 1.303-.05 1.25.306 10.607.331 10.832.025.224.329.275.329.275z'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
            <path
              fill='#ebeced'
              d='m414.06 317.79-2.638-.396c.54-1.022 1.162-1.493 1.162-1.493l3.065-.107-.019.027c-.629.145-1.185.879-1.57 1.969z'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
            <path
              fill='none'
              d='m370.87 327.53 1.801-.266 1.135-1.935 2.134-7.893 9.823-.521 1.961 7.986 2.293 2.295 3.727.334 9.89-.359'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
            <path
              fill='#fff'
              d='M378.56 315.8c.427-1.402 1.118-2.316 1.9-2.316.75 0 1.416.837 1.848 2.138-1.275.059-2.547.119-3.748.178z'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
            <g fill='#39a9dc'>
              <path
                d='m373.94 325.19 13.779-.281M373.94 324.29l13.779-.281M374.31 323.46l12.939-.477M374.31 322.61l12.939-.477M374.72 321.75l12.006-.604'
                transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
              />
            </g>
            <g fill='#fff'>
              <path
                d='M417.37 319.9c0-2.277-.774-4.123-1.73-4.123-.957 0-1.731 1.846-1.731 4.123s.774 4.123 1.731 4.123c.956 0 1.73-1.846 1.73-4.123zM428.05 320.93c0-1.553-.528-2.811-1.18-2.811s-1.18 1.258-1.18 2.811.528 2.813 1.18 2.813 1.18-1.26 1.18-2.813zM388.63 322.31s.367 1.201.801 1.801c.433.601 1.968.701 2.668.734.701.033 1.926 0 1.926 0s.009-1.834-.391-2.068c-.4-.235-5.004-.467-5.004-.467zM370.88 324.86s2.001-.002 2.335-.309c.334-.306.346-.441.346-.441l.142-1.533s-1.215-.03-1.889 0c-.455.017-.751.092-.751.092z'
                transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
              />
            </g>
            <path
              fill='#ebeced'
              d='m398.86 315.33-.324.465-2.436-.244c.096-.276-.121-.299.17-.914.563-1.182 1.279-1.715 1.279-1.715l3.064-.108-.019.028c-.724.166-1.352 1.115-1.734 2.488z'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
            <path
              fill='none'
              strokeMiterlimit={10}
              d='M400.82 324.03c-1.299 0-2.352-2.51-2.352-5.604 0-3.095 1.053-5.605 2.352-5.605s2.352 2.51 2.352 5.605c0 3.094-1.053 5.604-2.352 5.604z'
              transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
            />
          </g>
          <path
            fill='#ebeced'
            strokeWidth={0.572}
            d='m425.65 319.53-2.084-.313c.416-.744.871-1.085.871-1.085l2.436-.086-.015.023c-.479.109-.903.654-1.208 1.461z'
            transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
          />
          <path
            fill='#ebeced'
            strokeLinecap='square'
            strokeWidth={0.72}
            d='M404.63 353.61v-37.229l9.522 1.429a8.747 8.747 0 0 0-.242 2.094c0 2.277.775 4.123 1.731 4.123s1.73-1.846 1.73-4.123a9.38 9.38 0 0 0-.141-1.633l8.609 1.291c-.096.406-.15.873-.15 1.371 0 1.553.528 2.813 1.179 2.813.653 0 1.181-1.26 1.181-2.813 0-.371-.031-.726-.087-1.052l2.689.404v15.611z'
            transform='matrix(.31317 0 0 -.31496 -116.01 118.88)'
          />
        </g>
      </g>
    </StyledSVG>
  );
};
export default SVG;
